import classNames from 'classnames'
import {type CSSProperties, memo, useMemo} from 'react'
import {transferSource} from 'src/biz/utils'
import {Button, Popconfirm, Table as UITable} from 'src/ui'
import type {ButtonProps, TableColumnProps, TableProps} from 'src/ui'
import Provider from 'src/ui/Provider'
import locale from 'src/ui/locale'
// import apiHttp from 'src/helper/request'
import type {AnyObject, schemaApiType} from '../types'
import styles from './index.module.scss'
// console.log('styles', styles)

interface customRenderTypeProperties extends ButtonProps {
  typeAction: keyof typeof ActionsEnum
  customName?: string
  css: CSSProperties
  className: string
  renderComp?: React.ReactNode | ((text: string, record: AnyObject, index: number) => React.ReactNode)
  cusTomClick?: (text: string, record: AnyObject, index: number) => void // 点击回调
}

type ColumnsType = TableColumnProps<any> & {
  renderType?: customRenderTypeProperties
}
export type TablePropsType = TableProps & {
  columns: ColumnsType[] | string
  dataSource: any[] | string
  apiList?: schemaApiType
  deleteOK?: () => void
  rowKey?: string // table key 防止出现重复key
  onChange?: (pagination: any, filter: any, sorter: any, extra: any) => void
  themeType?: 'blue' | 'yellow'
  [key: string]: any
}

export enum ActionsEnum {
  Modify = 'Modify',
  Check = 'Check',
  Delete = 'Delete',
  CustomRender = 'CustomRender',
}

const TableComponent: React.FC<TablePropsType> = props => {
  const {deleteOK, columns, rowKey, dataSource, apiList, ...rest} = props
  const newDataSource = transferSource<any[]>(dataSource)
  const newColumns = transferSource<ColumnsType[]>(columns)
  const onHeaderCell = () => {
    const ob = {
      style: {
        borderBottom: 'none',
        height: '40px',
        padding: '0 16px',
        color: '#4B5363',
        fontWeight: '400',
      },
      onClick: () => {}, // 点击表头行
    }
    return ob
  }

  const updateColumn = useMemo(() => {
    return (newColumns || []).map((item: ColumnsType) => {
      if (!item.renderType) {
        item.onHeaderCell = onHeaderCell
        return item
      }

      const {typeAction, className, css, cusTomClick, customName, renderComp, ...rest} = item.renderType

      const renderButton = (defaultName: string, text: string, record: AnyObject, index: number) => (
        <div className={classNames(className)} style={css || {}}>
          <Button onClick={cusTomClick ? () => cusTomClick(text, record, index) : undefined} {...rest}>
            {customName || defaultName}
          </Button>
        </div>
      )

      switch (typeAction) {
        case ActionsEnum.Modify:
          item.render = (text: string, record: AnyObject, index: number) => renderButton('修改', text, record, index)
          break
        case ActionsEnum.Check:
          item.render = (text: string, record: AnyObject, index: number) => renderButton('查看', text, record, index)
          break
        case ActionsEnum.Delete:
          item.render = (text: any, record: any, index: any) => (
            <Popconfirm
              placement="topLeft"
              title={text}
              description={'是否确认删除该项'}
              okText="确定"
              cancelText="取消"
              onConfirm={async () => {
                deleteOK && deleteOK()
              }}
            >
              {renderButton('删除', text, record, index)}
            </Popconfirm>
          )
          break
        case ActionsEnum.CustomRender:
          if (!renderComp) {
            console.log('该属性需要和renderComp自定义操作组件一起使用!')
            item.render = () => <>未配置renderComp组件</>
          } else {
            item.render = (text: string, record: AnyObject, index: number) =>
              typeof renderComp === 'function' ? renderComp(text, record, index) : renderComp
          }
          break
        default:
          break
      }

      item.onHeaderCell = onHeaderCell
      return item
    })
  }, [columns, newColumns])

  const onChange = (pagination: any, filter: any, sorter: any, extra: any) => {
    props.onChange?.(pagination, filter, sorter, extra)
  }
  return (
    <Provider locale={locale} themeType={props.themeType}>
      <UITable
        dataSource={newDataSource}
        columns={updateColumn || []}
        rowKey={rowKey || 'key'}
        {...rest}
        onChange={onChange}
        className={styles.tableCompontent}
      />
    </Provider>
  )
}
export const Table = memo(TableComponent)
export default Table
